import { useMutation, useQueryClient } from "@tanstack/vue-query";
import PermissionService from "@/services/permission-service";
import { Permission } from "@/utils/permissions";

export interface UpdateRolePermissionsPayload {
  role: string;
  permissions: Permission[];
}

export function useUpdateRolePermissions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ role, permissions }: UpdateRolePermissionsPayload) => {
      const result = await PermissionService.updateRolePermissions(role, permissions);
      if (result.data?.status) {
        return result.data.data;
      }
      throw new Error(result.data?.msg || "Failed to update role permissions");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["role-permissions"] });
    },
  });
}
